import { render, staticRenderFns } from "./AppTopBar.vue?vue&type=template&id=0477bf36&scoped=true&"
import script from "./AppTopBar.vue?vue&type=script&lang=ts&"
export * from "./AppTopBar.vue?vue&type=script&lang=ts&"
import style0 from "./AppTopBar.vue?vue&type=style&index=0&id=0477bf36&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0477bf36",
  null
  
)

export default component.exports